"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'account.grades.free': '免费',
    'account.grades.free.description': '入门基本功能',
    'account.grades.free.feature1': '有限月度使用',
    'account.grades.free.feature2': '基础AI模型',
    'account.grades.free.feature3': '社区支持',
    'account.grades.basic': '基础',
    'account.grades.basic.description': '为普通用户提供增强功能',
    'account.grades.basic.feature1': '增加月度使用量',
    'account.grades.basic.feature2': '标准AI模型',
    'account.grades.basic.feature3': '邮件支持',
    'account.grades.pro': '专业',
    'account.grades.pro.description': '为专业人士提供高级功能',
    'account.grades.pro.feature1': '高月度使用量',
    'account.grades.pro.feature2': '高级AI模型',
    'account.grades.pro.feature3': '优先支持',
    'account.grades.ultra': '旗舰',
    'account.grades.ultra.description': '为高级用户提供最大功能',
    'account.grades.ultra.feature1': '无限使用',
    'account.grades.ultra.feature2': '所有AI模型',
    'account.grades.ultra.feature3': '专属支持',
};
